import { styled } from "@mui/system";
import { Typography, useTheme } from "@mui/material";

export const GenericDescriptionTypography = styled(Typography)(() => ({
  ...useTheme().custom.styles.primaryDescription,
  marginTop: "10rem",
  lineHeight: "2rem",
  whiteSpace: "pre-line",
}));
